import { Grid } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import img500 from '../assets/img/500.svg';
import Button from '@mui/material/Button';
import React from 'react';
import { useNavigate } from 'react-router-dom';
const useStyle = makeStyles({
  root: {
    width: '110px',
    height: '100px',
    padding: '55px 51.1px 55px 51px',
    boxShadow:
      '15px 15px 25px 0 rgba(172, 172, 172, 0.5), -15px -15px 25px 0 #ffffff',
    border: 'solid 1px #ffffff',
    backgroundColor: '#f5f5f5',
    borderRadius: '50%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center'
  },
  img: {
    width: '110px'
  },
  text: {
    fontSize: '21px',
    fontWeight: 'bold',
    color: '#707070'
  },
  ButtonStyle: {
    display: 'flex !important',
    justifyContent: 'center !important',
    alignItems: 'center !important',
    height: '48px',
    width: '100%',
    // boxShadow: '-1px -1px 1px 0  #ffffff',
    boxShadow:
      '-2px 2px 0px -1px rgba(172, 172, 172, 0.5), -4px -4px 1px 0 #ffffff',
    backgroundColor: '#f5f5f5',
    textAlign: 'center',
    margin: '30px !important',
    // marginTop:"30px !important",
    // marginBottom:"30px !important",

    color: '#753cbe'
  },
  ButtonLabel: {
    fontSize: '14px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    color: '#753cbe !important'
  }
});
export default function Error() {
  const classes = useStyle();
  const navigate = useNavigate();
  const handleClick = () => {
    // history.goBack()
    navigate('app/home');
  };
  return (
    <Grid container>
      <Grid style={{ height: '120px' }} item xs={12} />
      <Grid display="flex" justifyContent={'center'} item xs={12}>
        <div className={classes.root}>
          <img className={classes.img} src={img500} alt="" />
        </div>
      </Grid>
      <Grid style={{ height: '30px' }} item xs={12} />
      <Grid display="flex" justifyContent={'center'} item xs={12}>
        <p className={classes.text}>اشکال در برقراری ارتباط با شبکه !</p>
      </Grid>
      <Grid display="flex" justifyContent={'center'} item xs={12}>
        <Button
          className={classes.ButtonStyle}
          type="button"
          onClick={handleClick}
        >
          <span className={classes.ButtonLabel}>بازگشت به صفحه خانه</span>
        </Button>
      </Grid>
    </Grid>
  );
}
